module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.fagency.name.caption) + "\n            ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency && _vm.fagency.nza),
      expression: "fagency && fagency.nza"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(60, 104)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(tag.name) + "\n                ")])])
  }), 1)], 1), _vm._v(" "), _c(_vm.createNameComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createNameShortComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.accrStartDate),
      expression: "fagency.accrStartDate"
    }]
  }, [_vm._v("Дата аккредитации: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.fagency.accrStartDate)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.accrFinalDate),
      expression: "fagency.accrFinalDate"
    }]
  }, [_vm._v("Дата прекращения действия аккредитации: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.fagency.accrFinalDate)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.prolongationDate),
      expression: "fagency.prolongationDate"
    }]
  }, [_vm._v("Дата начала осуществления деятельности : "), _c('b', [_vm._v(_vm._s(_vm.fagency.accrStartDate ? _vm.formatDate(_vm.fagency.accrStartDate) : '-'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.prolongationDate),
      expression: "fagency.prolongationDate"
    }]
  }, [_vm._v("Дата решения о продлении срока действия аккредитации: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.fagency.prolongationDate)))])]), _vm._v(" "), _c('div', [_vm._v("\n                НЗА "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.fagency.nza)
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать нза', _vm.getCompanyNza), {
    tag: "v-component"
  }), _vm._v("\n                ИНН "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderInnHtml(_vm.fagency.inn))
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getCompanyInn), {
    tag: "v-component"
  }), _vm._v("\n                КПП "), _c('b', [_vm._v(_vm._s(_vm.fagency.kpp))]), _vm._v(" "), _c(_vm.renderCopyButton('Копировать кпп', _vm.getCompanyKpp), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('div', [_vm._v("\n              Вид обособленного подразделения: "), _c('b', [_vm._v(" " + _vm._s(_vm.fagency.kind === 'BRANCH' ? 'Филиал иностранного юридического лица' : 'Представительство иностранного юридического лица'))])]), _vm._v(" "), _c('div', [_vm._v("\n              Основной вид деятельности: "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderFirstActivityHtml(_vm.fagency.activities))
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("Численность иностранных сотрудников: "), _c('b', [_vm._v(_vm._s(_vm.fagency.staffNumber && _vm.fagency.staffNumber.value !== null ? _vm.fagency.staffNumber.value : 'нет данных'))])]), _vm._v(" "), _c(_vm.createAddressComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createHeadsComp(_vm.fagency.heads), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createForeignOrgComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notes)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('v-layout', {
    attrs: {
      "justify-begin": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.goDepo()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('span', [_vm._v("Перейти в депозитарий")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.privateNotes)
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("\n        Организация проводившая аккредитацию:\n        "), _c(_vm.createTaxOfficeComp(_vm.fagency.accrTaxOffice), {
    tag: "component"
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.fagency.taxCredential) ? _c('v-credentinals-panel', {
    attrs: {
      "fill-height": "",
      "tax": _vm.fagency.taxCredential
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [(_vm.fagency && _vm.fagency.reference && _vm.fagency.reference.inn) ? _c('v-client-preview-panel', {
    attrs: {
      "fill-height": "",
      "inn": parseInt(_vm.fagency.reference.inn),
      "clientId": _vm.fagency.clientId
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [(_vm.fagency && _vm.fagency.reference && _vm.fagency.reference.ref && _vm.getProfileHaveClient) ? _c('v-visit-panel', {
    attrs: {
      "fill-height": "",
      "topCount": 5,
      "refCode": _vm.fagency.reference.ref
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.fagency && _vm.fagency.reference) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', _vm.copyLink), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fagency && _vm.fagency.reference && _vm.getProfileHaveClient && !_vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', _vm.addFavorite), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fagency && _vm.fagency.reference && _vm.getProfileHaveClient && _vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', _vm.editNotesDialogOpen), {
    tag: "v-component"
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620ee15f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/ForeignAgencyPage.vue
// module id = 1105
// module chunks = 1